export default "__VITE_ASSET__31d42eb0__"